const base ={
    getUrl:"api/quartz/mealChange/getUrl",
    unsubscribea:"api/quartz/mealChange/unSubscribe",
    surveyQuestion:"api/quartz/mealChange/surveyQuestion",
    surveyAnswer:"api/quartz/mealChange/surveyAnswer",
}

export default base
